import {
  CREATE_PROCESS_NEW_RECORD,
  CREATE_PROCESS_NEW_RECORD_SUCCESS,
  CREATE_PROCESS_NEW_RECORD_ERROR,  
  
  GET_PROCESS_NEW_RECORD,
  GET_PROCESS_NEW_RECORD_SUCCESS,
  GET_PROCESS_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getProcessNewRecord = (processId, history, activityInfo) => ({
    type: GET_PROCESS_NEW_RECORD,
    payload: {processId, history, activityInfo}
  });

export const getProcessNewRecordSuccess = (recordCreated) => ({
  type: GET_PROCESS_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getProcessNewRecordError = (message) => ({
  type: GET_PROCESS_NEW_RECORD_ERROR,
  payload: { message },
});

export const createProcessNewRecord = (newRecord, history, activityInfo) => ({
    type: CREATE_PROCESS_NEW_RECORD,
    payload: {newRecord, history, activityInfo}
  });

export const createProcessNewRecordSuccess = (recordCreated) => ({
  type: CREATE_PROCESS_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createProcessNewRecordError = (message) => ({
  type: CREATE_PROCESS_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});